import React from 'react'
import CurrencyListTable from './Components/CurrencyListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PaymentCurrencyList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Currency List</HeadingOne>
          <AddItemBtn url="add-currency" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <CurrencyListTable />
      </div>
    </PageBody>
  );
};

export default PaymentCurrencyList;
